import { createI18n } from 'vue-i18n'
import messages from './locales'

class I18nInstance {
  private i18n: ReturnType<typeof createI18n>

  constructor() {
    this.i18n = createI18n({
      legacy: false,
      locale: 'he',
      fallbackLocale: 'en',
      messages,
    })
    this.setLocale()
  }

  setLocale(): void {
    const storageLocale = localStorage.getItem('locale')
    const supportedLocales = ['en', 'he']
    const browserLocaleSupported = supportedLocales.some((val) =>
      navigator.language.includes(val)
    )
    const validBrowserValue = browserLocaleSupported
      ? navigator.language.split('-')[0]
      : 'en'
    ;(this.i18n.global.locale as any).value = storageLocale || validBrowserValue
  }

  switchLocale(clickedValue: string): void {
    ;(this.i18n.global.locale as any).value = clickedValue
    localStorage.setItem('locale', clickedValue)
  }

  isLocale(locale: string): boolean {
    return (this.i18n.global.locale as any).value === locale
  }

  get instance() {
    return this.i18n
  }
}

export const i18nInstance = new I18nInstance()
export default i18nInstance.instance